import { AxiosInstance } from 'axios';
import { MemoriesBetaFacilityRepository } from '~/model/repository/manager/parentSales/MemoriesBetaFacilityRepository';

export default (Repository: AxiosInstance) => (): MemoriesBetaFacilityRepository => ({
  get(featureName: string) {
    return Repository.get(`/memories-api/v1/admin/beta-facilities`, {
      params: { featureName },
    });
  },
});
